import React from 'react';
import PropTypes from 'prop-types';
import IntegrationsModal from './integration_modal';

import contactIcon from '../images/contact_integration.svg';

export default class ContactModal extends React.Component {

  static propTypes = {
    currentDatabase: PropTypes.object,
    shown: PropTypes.bool,
    databases: PropTypes.array.isRequired,
    onCancel: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired
  };

  handleSave = (databaseId) => {
    const { onSave } = this.props;
    onSave(databaseId, "contacts");
  }

  render() {
    const { currentDatabase, shown, databases, onCancel } = this.props;

    return (
      <IntegrationsModal
        currentDatabase={currentDatabase}
        shown={shown}
        databases={databases}
        title="Connect Contact Sync"
        onCancel={onCancel}
        onSave={this.handleSave}
      >
        <div>
          <div className="mb-3 text-center">
            <img className="img-thumbnail modal-img" src={contactIcon}/>
          </div>
          <span>
            You are about to sync Buildout Contacts with your Google, Office, ICloud or Yahoo account
            <br/>
            Below, select what database you would like to sync.
          </span>
          <br/>
          <strong className="text-danger">
            All contacts created in this database will sync to your Nylas Account.
          </strong>
        </div>
      </IntegrationsModal>
    );
  }
}
